import { useState, useEffect } from "react";
import Image1 from "../../assets/WEBSITE/1PerfectSheltersConsult.webp";
import Image2 from "../../assets/WEBSITE/2PerfectSheltersConsult.webp";
import Image3 from "../../assets/WEBSITE/3PerfectSheltersConsult.webp";
import Image4 from "../../assets/WEBSITE/NEW ESTATE BUILDING 2-5-2026B9.webp";
import Image5 from "../../assets/WEBSITE/NEW ESTATE BUILDING 2-5-2026C1.webp";
import Image6 from "../../assets/WEBSITE/FLAT 14-2-20251A.webp";
import Image7 from "../../assets/WEBSITE/AI CENTER 19-2-2026D.webp";
import Image8 from "../../assets/WEBSITE/ESTATE DESIGN5.webp";
import Image9 from "../../assets/WEBSITE/LSR_2 - Photo.jpg";
import Image10 from "../../assets/WEBSITE/NEW ESTATE BUILDING 2-5-2026F.webp";
import { Link } from "react-router-dom";
import { BsWhatsapp } from "react-icons/bs";
import { MdKeyboardArrowDown } from "react-icons/md";

const slideImages = [
  Image1, Image2, Image3, Image4, Image5,
  Image6, Image7, Image8, Image9, Image10,
];

function HeroSection() {
  const [current, setCurrent] = useState(0);
  // Only render slides that have been reached — prevents loading all 10 images on startup
  const [rendered, setRendered] = useState(() => new Set([0]));
  // Slides that have started their zoom at least once — the zoom plays once per
  // slide and holds its final scale (via animation-fill-mode: forwards) rather
  // than resetting, so an outgoing slide never "un-zooms" mid-fade.
  const [zoomed, setZoomed] = useState(() => new Set([0]));

  useEffect(() => {
    // Longer than the 4.5s kenburns animation so the zoom always finishes before
    // the crossfade to the next slide begins, instead of being cut off mid-zoom.
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slideImages.length);
    }, 5500);
    return () => clearInterval(interval);
  }, []);

  // Pre-render the next slide as the current one is showing
  useEffect(() => {
    const next = (current + 1) % slideImages.length;
    setRendered((r) => {
      if (r.has(current) && r.has(next)) return r;
      const s = new Set(r);
      s.add(current);
      s.add(next);
      return s;
    });
    setZoomed((z) => (z.has(current) ? z : new Set(z).add(current)));
  }, [current]);

  return (
    <div className="relative">
      {/* Background slideshow */}
      <div className="relative h-screen overflow-hidden bg-gray-900">
        {slideImages.map((src, index) =>
          rendered.has(index) ? (
            <div
              key={index}
              className="absolute inset-0 overflow-hidden"
              style={{
                opacity: index === current ? 1 : 0,
                transition: "opacity 1200ms ease-in-out",
              }}
            >
              <img
                src={src}
                alt=""
                aria-hidden="true"
                fetchpriority={index === 0 ? "high" : "low"}
                className={`w-full h-full object-cover object-center ${zoomed.has(index) ? "kenburns" : ""}`}
              />
            </div>
          ) : null
        )}
      </div>

      {/* Top vignette — keeps navbar area dark for logo readability */}
      <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-black/60 to-transparent z-10 pointer-events-none" />

      {/* Gradient overlay + hero text */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/50 to-black/10 z-10 flex items-center">
        <div className="px-6 md:px-24 max-w-3xl pt-16 md:pt-20">
          <p className="text-[#1877F2] uppercase tracking-[0.3em] text-xs md:text-sm font-semibold mb-3 md:mb-4">
            Welcome to Perfect Shelters
          </p>
          <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold text-white leading-tight mb-4 md:mb-5 font-Montserrat">
            Your Dream Home,<br className="hidden sm:block" /> Built to Last
          </h1>
          <p className="text-white/80 text-sm md:text-lg leading-relaxed mb-7 md:mb-9 max-w-lg">
            Luxury architectural designs blending African and Western culture —
            crafted by experts with over 10 years of experience.
          </p>
          <div className="flex flex-wrap gap-3 md:gap-4">
            <Link
              to="/featured-house-plans"
              className="bg-[#1877F2] hover:bg-[#0e5fc7] text-white font-semibold py-3 px-7 md:px-9 rounded-full transition-colors duration-200 text-sm md:text-base"
            >
              Browse Plans
            </Link>
            <a
              href="https://wa.me/+2349033020343"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 border-2 border-white hover:bg-white hover:text-gray-900 text-white font-semibold py-3 px-7 md:px-9 rounded-full transition-all duration-200 text-sm md:text-base"
            >
              <BsWhatsapp />
              Chat With Us
            </a>
          </div>
        </div>
      </div>

      {/* Slide indicators */}
      <div
        className="absolute bottom-14 left-1/2 -translate-x-1/2 z-10 flex gap-2"
        role="tablist"
        aria-label="Slideshow navigation"
      >
        {slideImages.map((_, i) => (
          <button
            key={i}
            role="tab"
            aria-selected={i === current}
            aria-label={`Go to slide ${i + 1}`}
            onClick={() => setCurrent(i)}
            className={`w-2 h-2 rounded-full transition-all duration-300 focus:outline-none ${
              i === current ? "bg-white scale-125" : "bg-white/40 hover:bg-white/70"
            }`}
          />
        ))}
      </div>

      {/* Scroll cue */}
      <div
        className="absolute bottom-5 left-1/2 -translate-x-1/2 z-10 text-white/60 flex flex-col items-center animate-bounce"
        aria-hidden="true"
      >
        <span className="text-[10px] tracking-widest uppercase mb-0.5">Scroll</span>
        <MdKeyboardArrowDown className="text-xl" />
      </div>
    </div>
  );
}

export default HeroSection;
